import script from "./TopPart.vue?vue&type=script&setup=true&lang=js"
export * from "./TopPart.vue?vue&type=script&setup=true&lang=js"

import "./TopPart.vue?vue&type=style&index=0&id=183cc42c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-183cc42c"]])

export default __exports__